import Link from '@tiptap/extension-link';

/**
 * 약관 본문 링크 — 다른 약관 링크(data-policy-slug, href="#policy/{slug}")와 바깥 링크를 하나의 mark 로.
 * 서버(sanitizePolicyHtml)도 같은 모양만 남긴다: 다른 약관은 slug 로 주소를 다시 만들고, 바깥은 http(s)·mailto 만
 */
export const PolicyLink = Link.extend({
  name: 'policyLink',
  priority: 1001,

  addAttributes() {
    return {
      ...this.parent?.(),
      slug: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-policy-slug'),
        renderHTML: (attributes: Record<string, string | null>) =>
          attributes.slug ? { 'data-policy-slug': attributes.slug } : {},
      },
    };
  },

  parseHTML() {
    return [{ tag: 'a[href]' }];
  },

  renderHTML({ HTMLAttributes }) {
    if (HTMLAttributes['data-policy-slug']) {
      return [
        'a',
        { ...HTMLAttributes, class: 'policy-internal-link', target: null, rel: null },
        0,
      ];
    }
    return [
      'a',
      { ...HTMLAttributes, class: null, target: '_blank', rel: 'noopener noreferrer' },
      0,
    ];
  },
}).configure({ openOnClick: false, autolink: false, linkOnPaste: false });
